import React from 'react';

interface UpgradePromptProps {
  trigger: React.ReactNode;
  feature: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({ trigger }) => {
  return (
    <div>
      {trigger}
    </div>
  );
};